import { render, staticRenderFns } from "./DistributionRole.vue?vue&type=template&id=4fca71a6&"
import script from "./DistributionRole.vue?vue&type=script&lang=js&"
export * from "./DistributionRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports